import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
import { GoBackButton } from "../../../../../components/GoBackButton";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { showPotentialWarehouses } from "../../../../../services/offers/show-potential-warehouses";
import { LoadingBackDrop } from "../../../../../components/loader";
import PotentialWarehousesChoose from "./potential-warehouses-choose";
import { useState } from "react";
import { ShowPotentialWarehousesPayload } from "../../../../../services/offers/show-potential-warehouses/types";
import { useParams } from "react-router-dom";

const PotentialWarehousesList = () => {
  const queryClient = useQueryClient();
  const { id } = useParams();
  const [potentialWarehouses, setPotentialWarehouses] =
    useState<ShowPotentialWarehousesPayload[]>();

  const { data }: any = queryClient.getQueryState([
    "OrdersPricelistOffers",
  ])?.data;
  const getPotentialWarehouses = useQuery(
    ["PotentialWarehouses"],
    () =>
      showPotentialWarehouses({
        id_zamowienie: data.payload.id_zamowienie,
      }),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(res) {
        setPotentialWarehouses(res.data.payload);
      },
    }
  );

  if (getPotentialWarehouses.isLoading || potentialWarehouses === undefined) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <PotentialWarehousesListContainer>
        <PotentialWarehousesChoose
          orderId={data.payload.id_zamowienie}
          offerId={id}
          potentialWarehouses={potentialWarehouses}
        />
      </PotentialWarehousesListContainer>
    </>
  );
};

export default PotentialWarehousesList;

const PotentialWarehousesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 340px;
    width: 66%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  // width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
